(function() {
  var btns = document.querySelectorAll('[data-loading-text]');

  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener('click', function () {
      this.value = this.getAttribute('data-loading-text');
      this.classList.add('disabled');
    });
  }
})();